"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationConfiguration = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const valueForm_1 = require("../../../hooks/valueForm");
const Number_1 = require("../../Form/Field/Number");
const Total_1 = require("./Total");
require("./index.scss");
const className = 'pagination-configuration';
const PaginationConfiguration = (props) => {
    const { total, pageTotal, pagination, maxPageSize, setPageSize } = props;
    const [pageSize, setInternalPageSize] = (0, react_1.useState)(pagination.pageSize);
    (0, react_1.useEffect)(() => setInternalPageSize(pagination.pageSize), [pagination.pageSize]);
    const { field, } = (0, valueForm_1.useValueForm)({
        config: () => ({
            type: 'number',
            integer: true,
            positive: true,
            withoutZero: true,
            maxNumber: maxPageSize,
            modificators: 'small',
        }),
        value: pageSize,
        onChange: (value) => {
            setInternalPageSize(value);
            if (field([]).error)
                return;
            setPageSize(value);
        },
    });
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Number_1.FormFieldNumber, { ...field([]), step: 5, info: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PaginationConfiguration:MaxPageSize', defaultMessage: 'Max page size: {maxPageSize}', values: {
                    maxPageSize,
                } }), tooltipIconHidden: true, additionClassNames: `${className}__input` }),
        react_1.default.createElement(Total_1.Total, { pagination: pagination, pageTotal: pageTotal, total: total })));
};
exports.PaginationConfiguration = PaginationConfiguration;
//# sourceMappingURL=index.js.map